<div class="identification-column" [class.identification-column--with-avatar]="showAvatar()">
  @if (showAvatar()) {
    <div class="identification-column__avatar">
      @if (imageUrl()) {
        <img class="identification-column__image" [src]="imageUrl()" [alt]="name()" />
      } @else {
        <div
          class="identification-column__initials"
          [style.background-color]="avatarColor()"
        >
          {{ initials() }}
        </div>
      }
    </div>
  }

  <div class="identification-column__text">
    <span class="investor-name" matTooltip="{{ name() }}" matTooltipPosition="above">
      {{ name() | truncate: 40 | emptyValue }}
    </span>

    <span class="person-document">
      @if (documentLabel()) {
        {{ documentLabel() }} -
      }
      {{ documentNumber() | mask: documentMask | emptyValue }}
    </span>
  </div>
</div>
